var map = {
	"./black.png": "74e5",
	"./dataanalysis.png": "0747",
	"./dataanalysis1.png": "9cf2",
	"./icon.png": "03f2",
	"./nav.png": "5ff8",
	"./tab.png": "b309",
	"./tab1.png": "1ccf6",
	"./tanshan.png": "c707",
	"./xin.png": "034e",
	"./yj.png": "5c51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ea6";